import { PureComponent } from 'react';

import trackEvent from '../helpers/trackEvent';
import LinkIcon from './icons/LinkIcon';

import styles from '../styles/ReferralLinkStyle.module.css';

interface IReferralLinkProps {
  formattedUrl?: string;
  url: string;
}

interface IReferralLinkState {
  copyMessage?: string;
}

class ReferralLink extends PureComponent<IReferralLinkProps, IReferralLinkState> {
  public override state: IReferralLinkState = {};

  public onCopyClick = () => {
    const { url } = this.props;
    const tempInput = document.createElement('input');
    tempInput.setAttribute('style', 'position: absolute; left: -10000px; top: -10000px');
    tempInput.setAttribute('value', url);
    document.body.appendChild(tempInput);
    tempInput.select();
    // oxlint-disable-next-line typescript/no-deprecated -- The copy action keeps its synchronous clipboard fallback
    const success = document.execCommand('copy');
    document.body.removeChild(tempInput);
    // oxlint-disable-next-line typescript/no-deprecated -- Referral link copies move to a typed outcome in the package migration
    trackEvent('click', 'copy', {
      success,
      referralUrl: this.props.url,
    });
    if (!success) {
      this.setState({ copyMessage: 'Error copying' });
      return;
    }
    this.setState({ copyMessage: 'Copied!' });
  };

  public override render() {
    const { formattedUrl, url } = this.props;
    const { copyMessage } = this.state;

    return (
      <div className={styles.container}>
        <span className={styles['link-container']}>
          <span className={styles.icon}>
            {/* oxlint-disable-next-line typescript/no-deprecated -- Existing screens still import this icon while the icon migration is pending */}
            <LinkIcon />
          </span>
          <a
            className={styles.link}
            href={url}
            // oxlint-disable-next-line typescript/no-deprecated -- This interaction stays on the legacy event until the referral flow moves to a typed event
            onClick={trackEvent.bind(null, 'click', 'referral-link', {
              referralUrl: url,
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            {formattedUrl || url}
          </a>
        </span>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <span className={styles.button} onClick={this.onCopyClick} role="button" tabIndex={0}>
          {copyMessage || 'Copy'}
        </span>
      </div>
    );
  }
}

export default ReferralLink;
